
import { computed, defineComponent, onBeforeUnmount, onMounted, PropType, watch } from "vue"

import ymaps from 'yandex-maps'

// @components
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// @composable
import useMap from '@/common/new-composable/useMap'

export default defineComponent({
    name: 'new-map',
    components: {
        Loader,
        TheButton,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        center: {
            type: Array as PropType<number[]>,
            default: () => [43.25391893213578, 76.92523545812777],
        },
        zoom: {
            type: Number,
            default: 13
        },
        layer: {
            type: String as PropType<'yandex#map' | '2gis#map'>,
            default: 'yandex'
        },
        loadingText: {
            type: String,
            default: 'Загрузка карты...'
        },
        failedText: {
            type: String,
            default: 'При загрузке карты произошла ошибка'
        },
        failedButtonText: {
            type: String,
            default: 'Обновить'
        },
        controls: {
            type: Array as PropType<string[]>,
            default: () => []
        }
    },
    emits: ['map-ready', 'click', 'destroy'],
    setup(props, { emit }) {
        let map_instance = null as ymaps.Map | null

        const { state, loadMapScript, createMap, addGisLayer, changeLayer, setMapCenter } = useMap(onScriptLoaded)

        function onScriptLoaded() {
            const map = createMap(props.id, {
                center: props.center,
                zoom: props.zoom,
                controls: props.controls,
            })

            map.events.add('click', onMapClick)

            addGisLayer()
            map_instance = map

            emit('map-ready', map)
        }

        function onMapClick(event: ymaps.MapEvent) {
            emit('click', event)
        }

        onMounted(loadMapScript)

        onBeforeUnmount(() => {
            emit('destroy')
        })

        const isRenderingState = computed(() => state.is_loading || state.is_failed)

        watch(
            () => props.layer, 
            (new_layer) => {
                if (!map_instance) return
                changeLayer(map_instance as ymaps.Map, new_layer)
            }
        )

        watch(
            () => props.center,
            (new_center) => {
                if (!map_instance) return
                setMapCenter(map_instance as ymaps.Map, new_center)
            }
        )

        return {
            state,
            //
            isRenderingState
        }
    }
})
